// Static registry data for the curated Windie extension shelf.
export const MCPS = [
  {
    slug: "cua-driver",
    name: "Cua Driver",
    creator: "trycua",
    category: "Computer Use",
    tagline: "Native computer-use driver for agents.",
    description:
      "Give your agent a mouse, a keyboard, and a screen. Deterministic control of a real desktop from one interface.",
    tags: ["computer-use", "desktop", "driver"],
    href: "https://cua.ai/",
  },
  {
    slug: "desktop-commander",
    name: "Desktop Commander",
    creator: "wonderwhy-er",
    category: "Filesystem & Shell",
    tagline: "Filesystem, shell, and process control.",
    description:
      "Read, write, run — a careful set of primitives for the operating system. The workhorse.",
    tags: ["filesystem", "shell", "process"],
    href: "https://desktopcommander.app/",
  },
  {
    slug: "blender",
    name: "Blender",
    creator: "ahujasid",
    category: "3D & Creative",
    tagline: "Model, light, and render from prompt.",
    description:
      "A bridge into Blender for scene composition, geometry, and rendering — driven by natural language.",
    tags: ["3d", "creative", "render"],
    href: "https://blendermcp.org/",
  },
  {
    slug: "basic-memory",
    name: "Basic Memory",
    creator: "basicmachines-co",
    category: "Memory",
    tagline: "Portable, plain-text knowledge.",
    description:
      "A long-term memory layer that reads and writes markdown you actually own. No lock-in.",
    tags: ["memory", "notes", "markdown"],
    href: "https://basicmemory.com/",
  },
  {
    slug: "brightdata",
    name: "Brightdata",
    creator: "brightdata",
    category: "Web & Data",
    tagline: "Fetch the live web, at scale.",
    description:
      "Access clean, structured web data — search, scraping, and crawling — without stitching pipelines.",
    tags: ["web", "scraping", "data"],
    href: "https://brightdata.com/",
  },
];

export const PLUGINS = [];
export const SKILLS = [];
